import { Badge, styled } from '@mui/material';

const BadgeSelected = styled(Badge)(() => ({
  top: '0',
  right: '0',
  height: '32px',
  width: '32px',
  borderRadius: '50%'
}));

export default BadgeSelected;
